import dateFnsFormat from 'date-fns/format';
import dateFnsIsValid from 'date-fns/isValid';
import locale from 'date-fns/locale/pt-BR';
import dateFnsParse from 'date-fns/parse';
import { enStatus } from 'interface/course';
import { IUpsell, enUpsellTypeProduct, enUpsellType, IShowcaseBannerUpsell } from 'interface/upsell';
import { IUser } from 'interface/user';
import { SyntheticEvent } from 'react';
import { ACCESS_NEGATIVE_STATUS, CDN_BASE_URL, IS_APP } from 'settings';

declare let EduzzWidget: any;
declare let hj: any;

declare global {
  interface Window {
    dataLayer: object[];
  }
}

export const secondsToTimeString = (timeInSeconds: number, displayHours: boolean = false): string => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds / 60) % 60).toLocaleString([], { minimumIntegerDigits: 2 });
  const seconds = Math.floor(timeInSeconds % 60).toLocaleString([], { minimumIntegerDigits: 2 });
  if (displayHours || hours > 0) {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${minutes}:${seconds}`;
};

export const getTime = (date: string | Date) => {
  date = new Date(date);
  let currentDate = new Date();
  currentDate = new Date(currentDate.getTime() + -(180 - currentDate.getTimezoneOffset()) * 60 * 1000);

  const milliseconds = Math.abs(currentDate.getTime() - date.getTime());
  const seconds = Math.floor(milliseconds / 1000) || null;
  const minutes = Math.floor(seconds / 60) || null;
  const hours = Math.floor(minutes / 60) || null;
  const days = Math.floor(hours / 24) || null;

  if (days > 6) {
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${date.getFullYear()}`;
  }
  if (days > 1) {
    return getDayLabel(date.getDay());
  }
  if (days === 1) {
    return 'Ontem';
  }
  if (hours) {
    return `${hours} Hora${plural(hours)} atrás`;
  }
  if (minutes) {
    return `${minutes} Minuto${plural(minutes)} atrás`;
  }
  if (seconds > 10) {
    return `${seconds} Segundo${plural(seconds)} atrás`;
  }
  return 'Agora';
};

const plural = (value: number) => {
  return value > 1 ? 's' : '';
};

const getDayLabel = (dayNumber: number) => {
  switch (dayNumber) {
    case 0:
      return 'Domingo';
    case 1:
      return 'Segunda-feira';
    case 2:
      return 'Terça-feira';
    case 3:
      return 'Quarta-feira';
    case 4:
      return 'Quinta-feira';
    case 5:
      return 'Sexta-feira';
    case 6:
      return 'Sábado';
    default:
      return '';
  }
};

export const dateFormater = (date: string, format = 'dd/MM/yyyy') => {
  if (!date) return date;
  date = date.replace(/\+.+/gi, '').replace(/\..+$/gi, '');
  return dateFnsFormat(dateParse(date, 'yyyy-MM-dd HH:mm:ss'), format, { locale });
};

export function dateParse(value: any, format: string = null): Date {
  if (!value) return value;
  if (value instanceof Date) return value;

  const date = !format ? new Date(value) : dateFnsParse(value, format, new Date(), { locale });
  if (!dateFnsIsValid(date)) return value;

  return date;
}

export const isStatusNegative = (status: string): boolean => {
  return ACCESS_NEGATIVE_STATUS.includes(status);
};

export const haveTermsBeenAccepted = (status: string): boolean => {
  return status === enStatus.MUST_ACCEPT_TERM;
};

export const hjTagging = (tag: string) => {
  if (typeof hj !== 'undefined') {
    hj('tagRecording', [tag]);
  }
};

export const openUpsell = (
  e: SyntheticEvent,
  upsell: IUpsell | IShowcaseBannerUpsell,
  utmMedium: string,
  user?: IUser
) => {
  switch (upsell.show_type) {
    case enUpsellType.checkoutSun:
      upsellTypeCheckout(e, upsell, utmMedium, user);
      break;
    case enUpsellType.nutror:
      const baseUrl = window.location.pathname.startsWith('/v3') ? '/v3' : '';
      window.location.href = `${baseUrl}/curso/${upsell.external_url}`;
      break;
    case enUpsellType.externalUrl:
      const url = removeParamUrl([], upsell.external_url, [
        `utm_source=NUTROR`,
        `utm_campaign=DOMINIOEXTERNO`,
        `utm_content=${upsell.id}`,
        `TRK1=NUTROR`,
        `TRK2=DOMINIOEXTERNO`,
        `utm_medium=${utmMedium}`,
        `TRK3=${upsell.id}`,
      ]);
      window.open(url, '_blank');
      break;
    default:
      break;
  }
};

function upsellTypeCheckout(
  e: SyntheticEvent,
  upsell: IUpsell | IShowcaseBannerUpsell,
  utmMedium: string,
  user?: IUser
) {
  let c1cParams = '';
  const qs = {
    utm_source: 'NUTROR',
    utm_campaign: 'C1C',
    utm_content: upsell.id,
    TRK1: 'NUTROR',
    TRK2: 'C1C',
    TRK3: upsell.id,
    utm_medium: utmMedium,
    email: (!!user.email && user.email.trim()) || '',
    nome: (!!user.name && user.name.trim()) || '',
    // phone: '99999999999',
    // skip: 1
  };

  if (!!user && !!user.email) {
    c1cParams = `&email=${user.email.trim() || ''}&nome=${user.name.trim() || ''}`;
  }

  if (upsell.type === enUpsellTypeProduct.ticket) {
    const utmParams = `?utm_source=NUTROR&utm_campaign=TICKET&utm_content=${upsell.id}&TRK1=NUTROR&TRK2=TICKET&TRK3=${upsell.id}&utm_medium=${utmMedium}`;

    window.open(`https://sun.eduzz.com/${upsell.content}${utmParams}${c1cParams}`, '_blank');
    return;
  }

  if (upsell.type === enUpsellTypeProduct.services) {
    const utmParams = `?utm_source=NUTROR&utm_campaign=SERVICO&utm_content=${upsell.id}&TRK1=NUTROR&TRK2=SERVICO&TRK3=${upsell.id}&utm_medium=${utmMedium}`;

    window.open(`https://cs.eduzz.com/${upsell.content}${utmParams}${c1cParams}`, '_blank');
    return;
  }

  EduzzWidget(
    'Widget',
    {
      id: upsell.content,
      qs,
    },
    e.target
  );

  (window as any).Edz.Initiate();
}

export function imageCompress(imageBase64: string, width: number, height: number, x: number, y: number) {
  return new Promise<Blob>((resolve) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const imageObj = new Image();

    canvas.width = width;
    canvas.height = height;

    const onload = () => {
      context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);

      canvas.toBlob((blob) => resolve(blob));
    };

    imageObj.onload = onload;
    imageObj.src = imageBase64;
  });
}

export function getUrlParams(): { [key: string]: any } {
  const params = window.location.search
    .replace(/^\?/gi, '')
    .split('&')
    .reduce((acc, item) => {
      const parts = item.split('=');

      let value: any = decodeURIComponent(parts[1]).trim();
      switch (value) {
        case 'true':
          value = true;
          break;
        case 'false':
          value = false;
          break;
      }

      acc[parts[0]] = value;
      return acc;
    }, {});

  return params;
}

export function appPostMessage(message: string, data: any = {}): Promise<void> {
  const webView = (window as any).ReactNativeWebView;

  if (!IS_APP || !webView) return Promise.resolve();
  if (webView.postMessage) {
    webView.postMessage(JSON.stringify({ message, data }));
  }
  if ((window as any).postMessage) {
    (window as any).postMessage(JSON.stringify({ message, data }), '*');
  }

  return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}

export function getCdnUrl(path: string, fallbackPath: string = null) {
  if (!path) return fallbackPath;
  if (path.startsWith('http')) return path;
  return `${CDN_BASE_URL}${path}`;
}

export function getCourseHash() {
  const pathname = window.location.pathname;
  if (
    pathname === '/v3' ||
    pathname === '/v3/' ||
    pathname === '/' ||
    pathname.match(/\/(v3\/)?admin/) ||
    pathname.match(/\/(v3\/)?notificacoes/) ||
    pathname.match(/\/(v3\/)?conteudo/)
  ) {
    return '';
  }
  const courseHash = /\/(v3\/)?(convite\/|curso\/|cadastro\/)?(\w{8,40})/g.exec(pathname);
  const hash = courseHash ? courseHash[3] : null;
  if (hash) {
    return hash;
  }
  return '';
}

export function removeURLParameter(urlParameters: string, parameter: string) {
  const params = new URLSearchParams(urlParameters);
  params.delete(parameter);
  return `?${params.toString()}`;
}

export function removeParamUrl(key: string[], sourceURL: string, addParams: string[] = []) {
  let rtn = sourceURL.split('?')[0],
    param,
    paramsArr: string[] = [],
    queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';

  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      param = paramsArr[i].split('=')[0];
      if (!key.indexOf(param)) {
        paramsArr.splice(i, 1);
      }
    }
  }

  if (!addParams.length) {
    return rtn;
  }

  return rtn + '?' + paramsArr.concat(addParams).join('&');
}

export function slugify(string: string) {
  if (!string) return string;
  const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;';
  const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(p, (c) => b.charAt(a.indexOf(c)))
    .replace(/&/g, '-and-')
    .replace(/[^w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}
/**
 * If today, return only hour and minutes (hh:mm). If doesn't, return day and month (dd MMM.).
 */
export const dataToNotifications = (date: any): any => {
  if (!date) return null;

  if (new Date(date).getDate() === new Date().getDate()) {
    return dateFormater(date, 'p');
  }
  return `${dateFormater(date, 'dd')} ${dateFormater(date, 'MMM')}.`;
};

export function adjustDataForum(data: any) {
  if (!data) return null;
  const date = data.split(' ')[0];
  const time = data.split(' ')[1];

  if (new Date().getFullYear() - date.split('-')[0] >= 1) {
    return `${new Date().getFullYear() - date.split('-')[0]} atras`;
  }

  if (new Date().getMonth() + 1 - date.split('-')[1] >= 1 || new Date().getDate() - date.split('-')[2] >= 1) {
    return `${date.split('-')[2]} de ${getMonth(Number(date.split('-')[1]))}`;
  }
  return `Hoje às ${time}`;
}

function getMonth(month: number) {
  return months.get(month);
}

const months: Map<number, string> = new Map([
  [1, 'janeiro'],
  [2, 'feveiro'],
  [3, 'março'],
  [4, 'abril'],
  [5, 'maio'],
  [6, 'junho'],
  [7, 'julho'],
  [8, 'agosto'],
  [9, 'setembro'],
  [10, 'outubro'],
  [11, 'novembro'],
  [12, 'dezembro'],
]);

export const isMobile = {
  Android: () => navigator.userAgent.match(/Android/i),
  iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
  any: () => isMobile.Android() || isMobile.iOS(),
};
